/**
 * App branding — single source of truth for the company name and product
 * identity surfaced across the shell, document title, public pages, and
 * outbound email digests.
 *
 * Authenticated workspace branding should come from /api/auth/me. These
 * values are product/public fallbacks only.
 */

const env = (typeof process !== 'undefined' && process.env) || {};

export const PRODUCT_NAME = env.REACT_APP_PRODUCT_NAME || 'VizionOps';
export const COMPANY_NAME = env.REACT_APP_COMPANY_NAME || PRODUCT_NAME;
export const TAGLINE = env.REACT_APP_TAGLINE || 'See every location. Lead every outcome.';
export const PRODUCT_DESCRIPTOR = env.REACT_APP_PRODUCT_DESCRIPTOR || 'Multi-location performance platform';

/**
 * Format a browser tab / document title. Keeps the company name first so
 * the workspace identity is always visible even when the OS truncates.
 */
export function formatDocumentTitle(routeTitle, companyName = COMPANY_NAME) {
  const resolvedCompanyName = companyName || COMPANY_NAME || PRODUCT_NAME;
  if (!routeTitle) return `${resolvedCompanyName} · ${PRODUCT_NAME}`;
  return `${resolvedCompanyName} · ${routeTitle}`;
}
